import React, { useState, useEffect, useRef } from 'react';
import { ShoppingBag, MapPin } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export const SocialProofTicker = () => {
  const [purchases, setPurchases] = useState([]);
  const [current, setCurrent] = useState(null);
  const [visible, setVisible] = useState(false);
  const indexRef = useRef(0);

  useEffect(() => {
    fetch(`${API}/recent-purchases`)
      .then(r => r.json())
      .then(data => setPurchases(data.purchases || []))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (purchases.length === 0) return;

    const showNext = () => {
      const idx = indexRef.current % purchases.length;
      setCurrent(purchases[idx]);
      setVisible(true);
      indexRef.current = idx + 1;
      setTimeout(() => setVisible(false), 4500);
    };

    const firstTimer = setTimeout(showNext, 3000);
    const interval = setInterval(showNext, 15000);

    return () => {
      clearTimeout(firstTimer);
      clearInterval(interval);
    };
  }, [purchases]);

  if (!current) return null;

  const formatTime = (mins) => {
    if (mins < 60) return `${mins} min ago`;
    const hrs = Math.floor(mins / 60);
    return `${hrs}h ago`;
  };

  const typeLabel = {
    guide: 'Guide',
    bundle_5: 'Bundle',
    bundle_10: 'Advanced Bundle',
    bundle_category: 'Full System',
  };

  return (
    <div
      className={`fixed bottom-5 left-5 z-[9999] transition-all duration-500 ease-out ${
        visible
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      data-testid="social-proof-ticker"
    >
      <div className="bg-white rounded-xl shadow-2xl border border-gray-200 p-3.5 w-72">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-full bg-green-100 flex items-center justify-center shrink-0">
            <ShoppingBag className="w-4 h-4 text-green-600" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-sm text-gray-900 font-semibold leading-tight">
              {current.name}
            </p>
            <p className="text-xs text-gray-600 mt-0.5 line-clamp-2 leading-snug">
              purchased <span className="font-medium text-gray-800">{current.title}</span>
            </p>
            <div className="flex items-center gap-2 mt-1.5 flex-wrap">
              <span className="text-[10px] text-gray-400 flex items-center gap-0.5">
                <MapPin size={9} /> {current.city}
              </span>
              <span className="text-[10px] text-gray-400">
                {formatTime(current.minutes_ago)}
              </span>
              <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${
                current.product_type === 'bundle_category' ? 'bg-orange-100 text-orange-700' :
                current.product_type === 'bundle_10' ? 'bg-purple-100 text-purple-700' :
                current.product_type === 'bundle_5' ? 'bg-blue-100 text-blue-700' :
                'bg-gray-100 text-gray-600'
              }`}>
                {typeLabel[current.product_type] || 'Guide'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
